"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoad = void 0;
var react_1 = __importDefault(require("react"));
var aboutSlice_1 = require("../redux/slice/aboutSlice");
var banksListSlice_1 = require("../redux/slice/banksListSlice");
var selectors_1 = require("../redux/selectors");
var contactsSlice_1 = require("../redux/slice/contactsSlice");
var inStockSlice_1 = require("../redux/slice/inStockSlice");
var lastArrivalSlice_1 = require("../redux/slice/lastArrivalSlice");
var popularCarSlice_1 = require("../redux/slice/popularCarSlice");
var filterSlice_1 = require("../redux/slice/filterSlice");
var filterSlice_2 = require("../redux/slice/filterSlice");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var pageWithBanksList = ['/credit', '/installment', '/exchange', '/banks', '/car'];
var pageWithInStockList = ['/', '/cars'];
var pageWithLastArrivals = ['/'];
var pageWithPopularCars = ['/'];
var pageWithFilters = ['/cars', '/credit', '/installment', '/exchange'];
var includesPath = function (arrayPath, path) {
    var mainPath = '/' + path.split('/')[1];
    var result = arrayPath.includes(mainPath);
    return result;
};
var useLoad = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var banksList = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).banksList;
    var inStockList = (0, react_redux_1.useSelector)(selectors_1.inStockListSelector).inStockList;
    var lastArrivalsList = (0, react_redux_1.useSelector)(selectors_1.lastArrivalsSelector).lastArrivalsList;
    var popularCarsList = (0, react_redux_1.useSelector)(selectors_1.popularCarsSelector).popularCarsList;
    var filtersList = (0, react_redux_1.useSelector)(selectors_1.filtersSelector).state.filtersList;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var prevPathRef = react_1.default.useRef(pathname);
    var prevSearchParamsRef = react_1.default.useRef(searchParams);
    var shouldResetFilters = function () {
        var prevPath = prevPathRef.current;
        var wasCarsPage = includesPath(pageWithFilters, prevPath);
        var isCarsPage = includesPath(pageWithFilters, pathname);
        if (wasCarsPage && !isCarsPage) {
            return true;
        }
        return false;
    };
    react_1.default.useEffect(function () {
        var mainPath = '/' + pathname.split('/')[1];
        if (!banksList.length && pageWithBanksList.includes(mainPath)) {
            dispatch((0, banksListSlice_1.banksListLoader)());
        }
        if (!inStockList.length && includesPath(pageWithInStockList, pathname)) {
            dispatch((0, inStockSlice_1.inStockListLoader)());
        }
        if (!lastArrivalsList.length && includesPath(pageWithLastArrivals, pathname)) {
            dispatch((0, lastArrivalSlice_1.lastArrivalsLoader)());
        }
        if (!popularCarsList.length && includesPath(pageWithPopularCars, pathname)) {
            dispatch((0, popularCarSlice_1.popularCarsLoader)());
        }
        if (includesPath(pageWithFilters, pathname)) {
            var params = {
                brand_name: searchParams.get('brand_name') || undefined,
                model_name: searchParams.get('model_name') || undefined,
                generation: searchParams.get('generation_name') || undefined,
            };
            if (!filtersList.length) {
                dispatch((0, filterSlice_1.loadFilters)(params));
            }
        }
        return function () {
            if (shouldResetFilters()) {
                dispatch((0, filterSlice_2.resetFilters)());
            }
            if (mainPath === '/credit') {
                dispatch((0, banksListSlice_1.setTargetBankId)(null));
            }
            prevPathRef.current = pathname;
            prevSearchParamsRef.current = searchParams;
        };
    }, [
        pathname,
        searchParams,
        dispatch,
        banksList.length,
        inStockList.length,
        lastArrivalsList.length,
        popularCarsList.length,
        filtersList.length,
    ]);
    react_1.default.useEffect(function () {
        dispatch((0, contactsSlice_1.loadContacts)());
        dispatch((0, aboutSlice_1.loadAbout)());
    }, [dispatch]);
};
exports.useLoad = useLoad;
